// Создаем объект окружения для клиентского кода
// Это решение проблемы с import.meta.env, который не работает в браузере

// Для режима разработки будем получать значения из window.__ENV__ (который будет внедрен сервером)
declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

// Определяем типы для переменных окружения
interface EnvVariables {
  BUN_PUBLIC_API_BASE_URL: string;
  BUN_PUBLIC_ENV: string;
}

// Создаем и экспортируем объект с переменными
export const ENV: EnvVariables = {
  BUN_PUBLIC_API_BASE_URL: window.__ENV__?.BUN_PUBLIC_API_BASE_URL || 'https://engine.legitfam.pro/api/',
  BUN_PUBLIC_ENV: window.__ENV__?.BUN_PUBLIC_ENV || 'development',
};
